﻿import * as React from 'react';
import { TranslatedLabels } from '../../../../../../shared/types';
import { Translate } from '../../../../../../shared/LanguageService';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';

type NoSearchResultsProps = {
    labels: TranslatedLabels;
};

function NoSearchResults({ labels }: NoSearchResultsProps) {
    const containerStyle = {
        paddingTop: "18px",
        display: "flex", 
        alignItems: "center", 
        justifyContent: "center"
    }

    return (
        <Box className="no-search-result__container">
            <Grid container>
                <Grid item xs={12} className='heading-container'>
                    <span className="no-search-result__text">{labels.text}</span>
                </Grid>

                <Grid item container xs={12} sx={containerStyle}>
                    <div style={{ display: "flex", marginTop: "16px" }}>
                        <Chip 
                            label={labels.tip} 
                            color="success"
                            sx={{ 
                                backgroundColor: "#7BC67E", 
                                fontSize: "14px", 
                                margin: "12px"
                            }} 
                        />
                        <div style={{ paddingTop: "16px" }}>
                            <span className="tip-text">{labels.tipText}</span>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </Box>
    );
}

function NoSearchResultsTranslated() {
    const labels = {
        text: Translate('orders/list/no-search-result'),
        tip: Translate('orders/list/tip'),
        tipText: Translate('orders/list/tip-text')
    };
    return <NoSearchResults labels={labels} />;
}

export default NoSearchResultsTranslated;
